import { useAppSelector } from 'store/index';

export const useNewComplex = () => {
    return useAppSelector(({ complexes: { new: newComplex } }) => newComplex);
};
